import RecoverAccountByEmailPage from './RecoverAccountByEmailPage';

export default RecoverAccountByEmailPage;


// WEBPACK FOOTER //
// ./src/components/pages/RecoverAccountByEmailPage/index.js